<template>
  <div>
    <b-modal v-model="modalShow" centered hide-header hide-footer ok-disabled cancel-disabled>
      <div class="buttons">
        <so-close-button @click="handleCancel">
          <span>{{ $t('common.cancelCall') }}</span>
        </so-close-button>
      </div>
      <div class="d-block text-center modal-container">
        <div class="content">
          <div class="content-subject">{{ $t('common.callStaff') }}</div>
          <div class="content-desc">{{ $t('common.pleaseWaitTheEmployeeWillArriveShortly') }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as api from '@/api'
import { mapGetters } from 'vuex'

import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  components: {
    SoCloseButton,
  },
  computed: {
    ...mapGetters({
      modalShow: 'modal/isShowingCallingStaffModal',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      seatStatus: 'seat/getSeatStatus',
    }),
  },
  methods: {
    async handleCancel() {
      try {
        await api.callStaffCancel(this.shopId, this.seatNo)
        // 商品メニューページでモーダルが閉じられた際はメニューを更新する
        if (this.$route.name === 'shopMenu') {
          this.$store.commit('menu/setShouldUpdate', true)
        }
        this.$store.dispatch('modal/setShowingCallingStaffModal', false)
      } catch (error) {
        this.$store.dispatch('modal/setShowingSimpleErrorModal', true)
        this.$store.dispatch('modal/setShowingCallingStaffModal', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-container {
    margin-top: -110px;
  }
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-body {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.content {
  color: #222222;
  &-subject {
    font-size: 36px;
    margin-bottom: 18px;
  }
  &-desc {
    font-size: 18px;
  }
}
.buttons {
  position: absolute;
  left: 0;
  bottom: 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-desc {
  white-space: pre-wrap;
}
</style>
